import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { Actions } from '@/lib/types/actions';
import { useRouter, useNotification } from '@/composables';

/**
 * Props interface para ActionsGroup component
 */
interface Props {
	/** Array di azioni da mostrare */
	actions?: Actions;
}

// Props con default

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsGroup',
  props: {
    actions: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { actions: Actions };



// Composables
const router = useRouter();
const { error: showError } = useNotification();

// Computed properties
const shouldShowAllAsButtons = computed(() => {
	return props.actions.length <= 2;
});

const firstAction = computed(() => {
	return props.actions.length > 0 ? props.actions[0] : null;
});

const secondaryActions = computed(() => {
	return props.actions.slice(1);
});
// Action handlers
/**
 * Ottiene l'href per l'azione (priorità: to > '#')
 */
function getActionHref(action: Actions[number] | null): string {
	if (!action) {
		return '#';
	}
	if (typeof action.to === 'string') {
		return action.to;
	}
	return '#';
}

/**
 * Gestisce click con supporto per modificatori (Ctrl, Cmd, middle-click)
 */
function handleActionClick(action: Actions[number], event: MouseEvent): void {
	if (action.disabled) {
		event.preventDefault();
		return;
	}

	// Se è un click modificato E c'è un href valido, lascia che il browser gestisca
	const hasValidHref = typeof action.to === 'string';
	const isModifiedClick = event.ctrlKey || event.metaKey || event.button === 1;

	if (hasValidHref && isModifiedClick) {
		// NON prevenire - lascia comportamento nativo browser
		return;
	}

	// Click normale - esegui handler custom
	event.preventDefault();
	executeAction(action);
}

/**
 * Handler per dropdown items
 */
function handleDropdownClick(action: Actions[number], event: MouseEvent): void {
	handleActionClick(action, event);
}

/**
 * Esegue un'azione con error handling robusto
 */
function executeAction(action: Actions[number] | null): void {
	if (!action || action.disabled) {
		return;
	}

	try {
		// Priorità 1: handler custom
		if (action.handler) {
			action.handler();
			return;
		}

		// Priorità 2: navigazione programmatica (component + to)
		if (action.component === 'nuxt-link' && action.to) {
			router.push(action.to);
			return;
		}
	} catch (err) {
		console.error('❌ ActionsGroup: Error executing action:', err);
		showError("Si è verificato un errore durante l'esecuzione dell'azione.");
	}
}

return { __sfc: true,props, router, showError, shouldShowAllAsButtons, firstAction, secondaryActions, getActionHref, handleActionClick, handleDropdownClick, executeAction }
}

})